import { ApiService } from "../../api";
import { Bundle } from "./Bundle";

export interface IBundlePatch {
	name?: string;
	code?: string;
	library_ids?: number[];
}

/**
 * Functions for working with bundles.
 */
export class BundleService {
	protected apiService: ApiService;

	constructor() {
		this.apiService = new ApiService();
	}

	/**
	 * Find all product bundles
	 */
	public async findAll(): Promise<Bundle[]> {
		const bundleData = await this.apiService.get("/api/v1/product/bundles");
		const bundles = await bundleData.json();

		return Bundle.fromJsonArray(bundles);
	}

	/**
	 * Saves only the fields given.
	 */
	public async patch(id: number, fields: IBundlePatch): Promise<Bundle> {
		const response = await this.apiService.patch(
			`/api/v1/product/bundles/${id}`,
			fields,
		);
		return Bundle.fromJson(await ApiService.readJson(response));
	}

	public async create(bundle: Bundle): Promise<Bundle> {
		const bundleData = await this.apiService.post(
			`/api/v1/product/bundles/`,
			bundle,
		);
		const newBundle = await bundleData.json();
		return Bundle.fromJson(newBundle);
	}
}
